<template>
<div class="z-50">
  <IndexNotice v-if="isIndexTopNotice" style="transition: 0.3s;" />
  <header class="w-full z-50" ref="header" :class="{ headerSticky: !$store.state.isIndexTopNotice && $route.name !== 'magHouse' && $route.name !== 'classList' && $route.name !== 'themeList' && $route.name !== 'lesson', transitionHead: isScrollHead }">
    <div class="items-center hidden lg:flex bg-white lg:pl-6 xl:pl-12">
      <ul class="flex text-sm whitespace-no-wrap text-dark-Gray2 items-center tracking-wide">
        <li>
          <a href="https://school.liveabc.com/" target="_blank" class="pr-1 pb-2 pt-6 block hover:underline">Live互動美語</a>
        </li>
        <li class="pb-2 pt-6">|</li>
        <li>
          <a href="https://liveschool.liveabc.com/" target="_blank" class="px-1 pb-2 pt-6 block hover:underline">LiveSchool</a>
        </li>
        <li class="pb-2 pt-6">|</li>
        <li>
          <a href="https://pro.liveabc.com/" target="_blank" class="px-1 pb-2 pt-6 block hover:underline">Livelearning Pro</a>
        </li>
        <!-- <li class="pb-2 pt-6">|</li>
        <li>
          <a href="https://www.facebook.com/HowItWorksTW" target="_blank" class="px-1 pb-2 pt-6 block hover:underline">知識大圖解Facebook粉絲團</a>
        </li> -->
      </ul>
    </div>
    <div ref="nav" class="bg-white mainheader w-full z-50 relative" id="topHeader">
      <div class="top-header flex justify-between items-center">
        <ul class="flex nav px-2 lg:hidden">
          <li class="nav__all relative cursor-pointer" @click="toggleHamburger">
            <div class="flex items-center justify-center text-center cursor-pointer" :class="{ openMenu: isMenu }">
              <span class="navicon"></span>
            </div>
          </li>
        </ul>
        <div class="flex lg:w-4/5">
          <router-link :to="{ name: 'index' }" class="px-4 lg:px-0 py-3 lg:py-5" :class="{ scrollLogo: isScroll }" aria-label="Index" @click.native="isMenu = true ? isMenu = false : null">
            <div id="leftsection" class="flex items-center lg:pl-6 xl:pl-12 justify-center md:justify-start">
              <div class="logo h-5 md:h-6 lg:h-8 mobile-logo focus:outline-none">
                <img class="w-full h-full object-contain" src="~@/assets/logo/liveabc_logo.png" alt="logo">
              </div >
              <!-- <div class="logo h-5 md:h-6 lg:h-8 hidden md:block web-logo focus:outline-none">
                <img class="h-full object-contain " src="~@/assets/logo/LOGO_web.png" alt="liveabc_logo">
              </div > -->
            </div>
          </router-link>
        </div>

        <div id="rightsection" class="rightsection flex items-end h-full w-auto lg:pr-6">
          <div class="member header-button flex items-center md:items-end">
            <div class="dropdown relative inline-block mobile-hidden" v-if="authorized">
              <router-link :to="{ name: 'manage' }" class="cursor-pointer">
                <div id="accountName" class="dropbtn flex self-end items-center no-underline hover:no-underline">
                  <p class="mb-0 mr-1 text-center text-xs whitespace-no-wrap">
                    <span>{{ user?.name ?? 'user' }}</span>
                  </p>
                  <div class="header-button-accountNameimg relative flex items-center">
                    <font-awesome-icon icon="angle-down" class="absolute ml-1" />
                  </div>
                </div>
              </router-link>
              <div class="dropdown-content text-xs border">
                <router-link :to="{ name: 'order' }" class="cursor-pointer-b border px-3 py-4">
                  <p>訂單查詢</p>
                </router-link>
                <router-link :to="{ name: 'manage' }" class="cursor-pointer-b border px-3 py-4">
                  <p>修改資料</p>
                </router-link>
                <router-link :to="{ name: 'favorite' }" class="cursor-pointer-b border px-3 py-4">
                  <p>收藏清單</p>
                </router-link>
              </div>
            </div>
            <router-link :to="{ name: 'login'}" v-if="!authorized" :class="{ border0: isScroll }" @click.native="loginAction"
              class="flex flex-col cursor-pointer border-btn no-underline hover:no-underline mobile-hidden">
              <div class="header-button-img mx-auto">
                <font-awesome-icon :icon="['far', 'user']" />
              </div>
              <p class="mb-0 text-center text-xs" :class="{ 'hidden': isScroll }">登入</p>
            </router-link>
            <a v-else @click="signout" :class="{ border0: isScroll }"
              class="flex flex-col border-btn no-underline hover:no-underline cursor-pointer mobile-hidden">
              <div class="header-button-img mx-auto">
                <font-awesome-icon icon="user" />
              </div>
              <p class="mb-0 text-center text-xs" :class="{ 'hidden': isScroll }">登出</p>
            </a>
            <div class="flex flex-col border-btn mobile-hidden no-underline hover:no-underline cursor-pointer relative mobile-hidden"
                @click="openSearchBar" :class="{ border0: isScroll }">
              <div class="header-button-img mx-auto">
                <font-awesome-icon icon="search" />
              </div>
              <p class="mb-0 text-center text-xs mobile-hidden" :class="{ 'hidden': isScroll }">搜尋</p>

              <SearchBarWeb v-if="isSearch" v-on:closeSearchBar="closeSearchBar" :isScroll="isScroll" />

            </div>
            <div class="checkout flex flex-col border-btn no-underline hover:no-underline">
              <div class="header-button-img mx-auto relative cursor-pointer" @click="toCheckoutPage">
                <font-awesome-icon icon="shopping-cart" class="text-lg lg:text-base" />
                <span class='badge absolute m-0 flex items-center justify-center' id='CartCount'>
                  {{ $store.state.cart.num }}
                </span>
              </div>
              <p class="mb-0 text-center text-xs cursor-pointer mobile-hidden" @click.prevent="toCheckoutPage" :class="{ hidden: isScroll, border0: isScroll }">購物車結帳</p>
              <div class="dropdown relative hidden lg:inline-block">
                <div class="dropdown-content text-xs">
                  <p class="text-center py-3 textColorDarkBlack border-b border-t border-l bordercheckout">我的購物車</p>
                  <div v-if="cartNum !== 0" class="overflow-y-scroll dropdown-outer">
                    <ul>
                      <li v-for="(item, index) in cartList" :key="index">
                        <router-link :to="{ path: item.link }" target="_blank" class="py-3 px-2 flex cursor-pointer overflow-hidden border-l border-r border-b bordercheckout"
                          >
                          <div class="w-full flex">
                            <div class="w-1/4 p-1">
                              <img v-if="item.cover!==''" class="object-contain mx-auto" :src="item.cover" alt="preset_item">
                              <img v-else class="object-contain mx-auto" src="~@/assets/images/preset_item.png" alt="preset_item">
                            </div>
                            <div class="w-3/4 p-1 flex flex-col justify-between">

                              <div class="font-semibold textColorBlack">
                                <p class="text-xs textColorBlack">
                                  <span v-if="item.type === 'MAGAZINE'">雜誌</span>
                                  <span v-if="item.type === 'SUBSCRIPTION'">訂閱</span>
                                  <span v-if="item.type === 'BOOK'">叢書</span>
                                  <span v-if="item.type === 'PACKAGE'">套書</span>
                                  <span v-if="item.type === 'ITEM'">商品</span>
                                </p>
                                <p class="text-xs whitespace-pre-wrap textColorBlack">{{ item.type === 'SUBSCRIPTION' ? item.link_name : item.name }}</p>
                                <p class="text-xs textColorBlack mt-2" v-if="item.type === 'SUBSCRIPTION'">期數: {{ item.name }}</p>
                              </div>

                              <div class="flex justify-between textColorBlack mt-4">
                                <p class="opacity-0 textColorBlack" :class="{ 'opacity-100': item.type === 'SUBSCRIPTION' && !item.is_digital }">寄送: <span v-if="item.isRegisteredMail">掛號</span><span v-if="!item.isRegisteredMail">平信</span></p>
                                <p class="text-xs textColorBlack">數量: {{item.quantity}}</p>
                              </div>

                            </div>
                          </div>
                        </router-link>
                      </li>
                    </ul>

                  </div>
                  <div v-else class="px-3 py-4 border-l border-r">
                    <p>
                      <span>購物車 0 商品</span>
                    </p>
                  </div>
                  <div class="bgLiveMainBlack p-3 text-center cursor-pointer overflow-hidden"
                    @click.prevent="toCheckoutPage">
                    <div class="contents text-xs">
                      <p class="text-white">立即結帳</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-header hidden lg:block" :class="{ 'borderB': $route.name === 'magHouse' || $route.name === 'classList' || $route.name === 'themeList' || $route.name === 'lesson' }" v-if="$route.name !== 'groupBuyingTag'">
        <div class="flex flex-wrap">
          <div class="w-full md:w-7/12 flex items-center bottom-header-btn">
            <ul class="flex justify-start md:justify-center w-full nav px-3 xl:px-8 h-full" v-if="$route.name === 'magHouse' || $route.name === 'classList' || $route.name === 'themeList' || $route.name === 'lesson'">
              <li class="flex flex-1 justify-center" v-for="(item, index) in knowledgeData" :key="index">
                <a @click="anchor(item.text)" class="bottom-header-text w-full flex items-center justify-center no-underline hover:no-underline px-1 cursor-pointer">
                  <p class="m-0 break-words whitespace-pre-wrap" :class="{ textScroll: isScroll }">
                    <span class="whitespace-pre">{{ item.title }}</span>
                  </p>
                </a>
              </li>
            </ul>
            <!-- 測試站 -->
            <ul class="flex justify-start md:justify-center w-full nav px-3 xl:px-8 h-full lg:pl-6 xl:pl-12" v-if="$store.state.nodeEnv !== 'production' && $route.name !== 'magHouse' && $route.name !== 'classList' && $route.name !== 'themeList' && $route.name !== 'lesson'">
              <li class="flex flex-1 justify-start" v-for="(item, index) in menuDataDev" :key="index">
                <router-link :to="{ name: item.routerName, params:{ category: item.category }, query: { scope: item.scope, type: item.type } }"
                  class="bottom-header-text w-full flex items-center justify-start no-underline hover:no-underline px-1 cursor-pointer text-center">
                  <p class="m-0 break-words whitespace-pre-wrap  tracking-widest" :class="{ 'textScroll': isScroll }">
                    <span class="whitespace-pre">{{ item.title }}</span>
                  </p>
                </router-link>
              </li>
            </ul>
            <!-- 正式站 -->
            <ul class="flex justify-start md:justify-center w-full nav px-3 xl:px-8 h-full lg:pl-6 xl:pl-12" v-if="$store.state.nodeEnv === 'production' && $route.name !== 'magHouse' && $route.name !== 'classList' && $route.name !== 'themeList' && $route.name !== 'lesson'">
              <li class="flex flex-1 justify-start" v-for="(item, index) in menuData" :key="index">
                <router-link :to="{ name: item.routerName, params:{ category: item.category }, query: { scope: item.scope, type: item.type } }"
                  class="bottom-header-text w-full flex items-center justify-start no-underline hover:no-underline px-1 cursor-pointer text-center">
                  <p class="m-0 break-words whitespace-pre-wrap  tracking-widest" :class="{ 'textScroll': isScroll }">
                    <span class="whitespace-pre">{{ item.title }}</span>
                  </p>
                </router-link>
              </li>
            </ul>

          </div>
          <router-link class="playerBtn-bg w-full md:w-5/12 hidden md:flex cursor-pointer" :to="{ name: 'dailySentence' }">
            <div class="playerBtn flex items-center justify-center"
              :class="{ playerBtnScroll: isScroll }">
              <img class="object-contain red h-6" src="@/assets/icon/comment-dots-regular-red.svg" alt="liveABC">
              <img class="object-contain black h-6" src="@/assets/icon/comment-dots-regular.svg" alt="liveABC">
            </div>
            <div class="dailyEnglish-content w-full flex items-center cursor-pointer">
              <div class="goodSentence pr-2 flex items-center">
                <p class="m-0 text-sm noplaying">
                  每日一句：
                  <span class="english tracking-wider" v-if="dailyData && dailyContent" v-html="forceToJap(dailyContent.english)"></span>
                  <span class="local tracking-wider" v-if="dailyData && dailyContent">{{ dailyContent.local }}</span>
                  <span class="tracking-wider" v-else>--</span>
                </p>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <SearchBarMobile class="lg:hidden" />

        <!-- 手機板每日一句 -->
        <router-link class="playerBtn-bg w-full flex cursor-pointer lg:hidden" :to="{ name: 'dailySentence' }">
          <div class="playerBtn flex items-center justify-center"
            :class="{ playerBtnScroll: isScroll }">
            <img class="object-contain red h-6" src="@/assets/icon/comment-dots-regular-red.svg" alt="liveABC">
            <img class="object-contain black h-6" src="@/assets/icon/comment-dots-regular.svg" alt="liveABC">
          </div>
          <div class="dailyEnglish-content w-full flex items-center cursor-pointer">
            <div class="goodSentence pr-2 flex items-center">
              <p class="m-0 text-xs noplaying">
                <span class="english tracking-wider" v-if="dailyData && dailyContent" v-html="forceToJap(dailyContent.english)"></span>
                <span class="local tracking-wider" v-if="dailyData && dailyContent">{{ dailyContent.local }}</span>
                <span class="tracking-wider" v-else>--</span>
              </p>
            </div>
          </div>
        </router-link>
        <!-- 手機板每日一句 -->
    </div>

    <MenuMobile :isMenu="isMenu" v-on:closeMobileMenu="closeMobileMenu" class="lg:hidden" />

    <!-- <DailySentencePop :dailyContent="dailyContent" v-on:close="close" v-if="isOpenDailyText" /> -->

  </header>

  <div id="member-box" class="fixed bottom-0 left-0 w-full z-50 lg:hidden" v-if="$store.state.nodeEnv !== 'production'">
    <ul class="flex bg-white">
      <li class="flex-1">
        <router-link :to="{ name: 'index' }" class="block px-3 py-4">
          <div class="flex flex-col justify-center items-center">
            <font-awesome-icon icon="home" /><p class="text-xs">首頁</p>
          </div>
        </router-link>
      </li>
      <li class="flex-1">
        <a v-if="authorized" class="block px-3 py-4 cursor-pointer" @click="signout">
          <div class="flex flex-col justify-center items-center">
            <font-awesome-icon icon="user" /><p class="text-xs">登出</p>
          </div>
        </a>
        <router-link :to="{ name: 'login' }" v-else class="block px-3 py-4">
          <div class="flex flex-col justify-center items-center">
            <font-awesome-icon :icon="['far', 'user']" /><p class="text-xs">登入</p>
          </div>
        </router-link>
      </li>
      <li class="flex-1">

      <router-link :to="{ name: 'manage' }" v-if="authorized" class="block px-3 py-4">
        <div class="flex flex-col justify-center items-center">
          <font-awesome-icon icon="user-friends" /><p class="text-xs">會員中心</p>
        </div>
      </router-link>
      <router-link :to="{ name: 'register' }" v-else class="block px-3 py-4">
        <div class="flex flex-col justify-center items-center">
          <font-awesome-icon icon="user-friends" /><p class="text-xs">註冊</p>
        </div>
      </router-link>
      </li>
      <li class="flex-1">
        <a class="block px-3 py-4 cursor-pointer" @click.prevent="toCheckoutPage">
          <div class="flex flex-col justify-center items-center">
            <font-awesome-icon icon="shopping-cart" class="" /><p class="text-xs">購物車</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import { mapGetters } from 'vuex'
import axios from 'axios'
import SearchBarMobile from '@/components/modules/SearchBarMobile'
import SearchBarWeb from '@/components/modules/SearchBarWeb'
import MenuMobile from '@/components/modules/Mobile_Menu'
import IndexNotice from '@/components/modules/IndexNotice'
import Bus from '@/components/modules/bus.js'
import langMixin from '@/components/modules/langMixin'
export default {
  name: 'headerSection',
  data () {
    return {
      fullWidth: null,
      isPlaying: false,

      isSearch: false,
      searchVal: null,

      dailyData: null,

      isMenu: false,

      isScroll: false,

      menuData: [
        { title: '最新優惠', routerName: 'productsList', category: 'recent' },
        { title: '雜誌館', routerName: 'magazine' },
        { title: '叢書館', routerName: 'productsList', category: 'book', type: 'BOOK' },
        { title: '套書館', routerName: 'productsList', category: 'package', type: 'PACKAGE' },
        // { title: '點讀館', routerName: 'readpen' },
        // { title: '數位學習', routerName: 'learning' },
        { title: '點讀館', routerName: 'productsList', category: 'livepen', scope: 'livepen' },
        { title: '數位學習', routerName: 'productsList', category: 'digital', type: 'MAGAZINE,DIGITAL' },
        { title: '下載專區', routerName: 'download', category: 'download' }
      ],
      menuDataDev: [
        { title: '最新優惠', routerName: 'productsList', category: 'recent' },
        { title: '雜誌館', routerName: 'magazine' },
        { title: '叢書館', routerName: 'productsList', category: 'book', type: 'BOOK' },
        { title: '套書館', routerName: 'productsList', category: 'package', type: 'PACKAGE' },
        { title: '點讀館', routerName: 'productsList', category: 'livepen', scope: 'livepen' },
        { title: '數位學習', routerName: 'productsList', category: 'digital', type: 'MAGAZINE,DIGITAL' },
        { title: '主題專欄', routerName: 'topicList', category: '' },
        { title: '下載專區', routerName: 'download', category: 'download' }
      ],
      knowledgeData: [
        { title: '雜誌館', routerName: 'productsList', category: 'recent', isProduction: true, text: 'mag' },
        { title: '主題館', routerName: 'magazine', isProduction: true, text: 'topic' }
      ],

      scrollPos: 0,
      isScrollHead: false,

      time: null,
      showLang: 'en'
    }
  },
  mixins: [
    langMixin
  ],
  components: {
    SearchBarMobile,
    SearchBarWeb,
    MenuMobile,
    IndexNotice
  },
  watch: {
    '$route' (to, from) {
      let self = this
      if (to.name !== from.name || to.path !== from.path || to.query !== from.query) {
        self.isMenu = false
        self.isSearch = false
        self.isScrollHead = false
      }
    }
  },
  updated () {
  },
  computed: {
    ...mapGetters([
      'userRole',
      'authorized',
      'user',
      'cartNum',
      'cartList',
      'totalPrice',
      'isIndexTopNotice'
    ]),
    dailyContent () {
      const [first] = this.dailyData || []
      if (!first) return {}

      if (this.showLang === 'jp' && first.jp) {
        return first.jp
      }
      return first
    }
  },
  created () {
    this.getData()
    this.timer()
  },
  mounted () {
    window.addEventListener('scroll', this.stickyHead)
    window.addEventListener('resize', this.updateFullWidth)

    Bus.$on('openDailySentence', (val) => {
      this.dailyContent = val
    })
  },
  beforeDestroy () {
    clearInterval(this.time)
    window.removeEventListener('scroll', this.stickyHead)
    window.removeEventListener('resize', this.updateFullWidth)
  },
  methods: {
    stickyHead () {
      let self = this
      // var header = self.$refs.header
      // var sticky = header.offsetTop

      // window.pageYOffset > sticky ? self.$store.dispatch('isIndexTopNotice', false) : self.$store.dispatch('isIndexTopNotice', true)

      window.pageYOffset > 160 ? self.isScroll = true : self.isScroll = false
      // window.pageYOffset > 200 ? self.scrollToHidden() : null
    },
    scrollToHidden () {
      let self = this

      if ((document.body.getBoundingClientRect()).top > self.scrollPos) {
        self.isScrollHead = false
      } else {
        self.isScrollHead = true
      }

      self.scrollPos = (document.body.getBoundingClientRect()).top
    },
    toggleHamburger () {
      let self = this
      self.isMenu = !self.isMenu
      if (self.isIndexTopNotice) {
        self.$store.dispatch('isIndexTopNotice', false)
        self.$cookie.set('expireCookie', '1D', { expires: '1D' })
        self.$store.dispatch('isIndexTopMainBody', true)
      }
    },
    checkToken () {
      let self = this
      if (self.authorized) {
        self.$store.dispatch('getProfile')
      }
    },
    getData () {
      let self = this
      axios.get('/daily-sentences?page=1&pageSize=1')
        .then((response) => {
          self.dailyData = response.data.data
        })
    },
    getFullWidth () {
      this.fullWidth = window.innerWidth
      window.onresize = () => {
        this.fullWidth = window.innerWidth
      }
    },
    updateFullWidth () {
      this.fullWidth = window.innerWidth
    },
    openSearchBar () {
      let self = this
      self.isSearch = true
    },
    closeSearchBar (closeSearchBar) {
      let self = this
      self.isSearch = closeSearchBar
    },
    signout () {
      let self = this
      self.$store.dispatch('logout')

      let path = self.$route.path
      if (path.includes('/user') || path.includes('/favorite') || path.includes('/checkout')) {
        self.$router.push({ name: 'index' })
      }
    },
    async toCheckoutPage () {
      let self = this
      if (!self.authorized) {
        self.$router.push({ name: 'login' })
        self.$store.dispatch('routeRecord', { routeName: 'checkout' })
      } else {
        // await self.$store.dispatch('getProfile')
        self.$router.push({ name: 'checkout' })
        self.$store.dispatch('routeRecord', { routeName: 'index' })
      }
    },
    close (close) {
      // this.isOpenDailyText = close
      this.dailyContent = this.dailyData[0]
    },
    closeMobileMenu (closeMobileMenu) {
      this.isMenu = false
    },
    anchor (text) {
      let self = this
      if (text && self.$route.name === 'magHouse') {
        Bus.$emit('anchor', text)
      } else {
        self.$router.push({ name: 'magHouse' })
      }
    },
    // replaceQuery () {
    //   let query = Object.assign({}, this.$route.query)
    //   delete query.category
    //   this.$router.replace({ query })
    // },
    loginAction () {
      this.$store.dispatch('routeRecord', { routeName: 'index' })
    },
    openPopup () {
      this.isOpenDailyText = true
    },
    timer () {
      let self = this
      self.time = setInterval(() => {
        if (self.showLang === 'en') {
          self.showLang = 'jp'
        } else {
          self.showLang = 'en'
        }
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
.transitionHead {
  transition: .4s;
  transform: translateY(-110%);
}
.border0 {
  border-width: 0 !important;
}
.borderB {
  // border-bottom: #e60012 2px solid;
}
.square-header {
  position: relative;
  width: 100%;
  padding-bottom : 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: transparent;
  background-origin: padding-box;
  .square-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding-bottom : 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
header {
  z-index: 999;
  transition: .3s;
}
.headerSticky {
  position: fixed !important;
  top: 0;
  width: 100%;
}
.mainheader {
  z-index: 99;
  // top-header
  .top-header {
      // border-bottom: 2px solid #E50012;
      #leftsection {
        height: 25px;
        @media (max-width:1023px) {
          height: 25px;
        }
        .logo {
          height: 25px;
          transition: .2s;
        }
        .logo-text {
          color: #263238;
        }
      }
        .scrollLogo {
          padding-top: .8rem !important;
          padding-bottom: .8rem !important;
          .web-logo {
            height: 1.5rem !important;
          }
        }
      #rightsection {
        .header-button {
          // droplist
          .dropbtn {
            padding-bottom: 10px;
            padding-right: 14px;
            height: 100%;
            border: none;
            cursor: pointer;
            p {
              font-weight: 500;
              color: #898989;
              font-size: 15px;
            }
            .header-button-accountNameimg {
              width: 22px;
              height: 22px;
              .fas {
                color: #898989;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
              }
              .fa-angle-down {
                transition: .2s linear;
                transform-origin: center;
              }
            }
          }
          .dropdown:hover {
            .fa-angle-down {
              transform-origin: center;
              // transform: rotate(-180deg);
            }
          }

          .dropdown:hover {
            .dropdown-content {
              opacity: 1;
              top: 2rem !important;
            }
          }
          .checkout:hover {
            .dropdown-content {
              opacity: 1;
              top: 0px !important;
            }
          }
          .dropdown-outer {
            max-height: 30em;
          }
          .dropdown-outer::-webkit-scrollbar-track {
            background-color: transparent;
          }

          .dropdown-outer::-webkit-scrollbar {
            width: 3px;
            background-color: transparent;
          }

          .dropdown-outer::-webkit-scrollbar-thumb {
            background-color: #898989;
          }

          .dropdown-content {
            top: -99999px;
            opacity: 0;
            position: absolute;
            background-color: #ffffff;
            min-width: 9rem;
            z-index: 10;
            right: 0;
            transition: opacity 0.5s ease;
            a {
              text-decoration: none;
              display: block;
              font-weight: 400;
              color: #898989;
              transition: .3s;
              &:hover {
                background-color: #EEEEEE;
              }
            }
          }

          .checkout .dropdown-content {
            left: -13.5rem;
            width: 24em;
            transform: translateY(.7rem);
          }
        }
        .mobile-hidden-border {
          border-top-width: 1px;
          border-right-width: 1px;
          border-bottom-width: 1px;
        }
        // btn
        .border-btn {
          width: 4.5rem;
          padding: 11px 0;
          @media (max-width:769px) {
            padding: 14px 0;
          }
          .header-button-img {
            text-align: center;
            .fa-user, .fa-search, .fa-user-slash, .fa-shopping-cart {
              color: #898989;
            }
            #CartCount {
              font-size: 10px;
              background: #D80303;
              color: #fff;
              right: -0.7rem;
              top: -0.4rem;
              padding: 0 5px;
              vertical-align: top;
              font-weight: 700;
            }
          }
          p {
            color: #898989;
            font-weight: 400;
            transition: .2s !important;
          }
        }
      }

    }
  #knowledge {
    background-color: #333;
    border-top: #e60012 2px solid;
    // border-bottom: #e60012 3px solid;
    color: #FFF;
    margin: 0;
    position: relative;
    padding: 2.5% 0 0;
    min-height: 280px;
    background: url('~@/assets/images/knowledge.jpg') no-repeat 0 bottom #1b1b37;
    background-size: cover;
    @media (max-width: 768px) {
      padding: 12% 0 0;
    }
    @media (max-width: 667px) {
      padding: 10% 0;
      min-height: 200px;
    }
  }
  // bottom-header
  .bottom-header {
    .bottom-header-btn {
      .bottom-header-text {
        @media (max-width:1023px) {
          height: 48px;
        }
        p {
          color: #263238;
          transition: .3s;
          text-align: center;
          font-size: 14px;
          // letter-spacing: 1px;
          font-weight: 600;
          word-break: break-all;
          white-space: pre-line;
          @media (min-width:1280px) {
            font-size: 15px;
          }
        }

        .textScroll {
          font-size: 14px !important;
        }
        &:hover {
          p {
            color: #e60012 !important;
          }
        }
      }
    }

  }
  .mobile-hidden {
    @media (max-width:1023px) {
      display: none !important;
    }
  }
  .mobile-hidden-border {
    @media (max-width:1023px) {
      border-top-width: 0px !important;
      border-right-width: 0px !important;
      border-bottom-width: 0px !important;
    }
  }
}

@media (max-width:1023px) {
  .nav__all {
    display: block;
    a, div {
      padding: 0;
      width: 44px;
      height: 44px;
      span {
        background: #303030;
        display: block;
        height: 2px;
        position: relative;
        transition: .2s ease-out;
        width: 18px;
        &:before {
          top: 5px;
          background: #303030;
          content: "";
          display: block;
          height: 100%;
          position: absolute;
          transition: all .2s ease-out;
          width: 100%;
        }
        &:after {
          top: -5px;
          background: #303030;
          content: "";
          display: block;
          height: 100%;
          position: absolute;
          transition: all .2s ease-out;
          width: 100%;
        }
      }
    }
    .openMenu {
      span {
        background: transparent;
        &:before {
          top: 0px;
          transform: rotate(45deg);
        }
        &:after {
          top: 0px;
          transform: rotate(-45deg);
        }
      }
    }
  }
}
      .playerBtn-bg {
        // background: #525050;
        .playerBtn {
          width: 55px;
          height: 55px;
          // background: #E50012;
          transition: .3s;
          .far {
            line-height: 46px;
          }
          .red {
            display: none;
            transition: .3s;
          }
          .black {
            display: block;
          }
          &:hover {
            .red {
              display: block;
            }
            .black {
              display: none;
            }
          }

        }
        .playerBtnScroll {
          width: 46px;
          height: 46px;
        }
        .dailyEnglish-content {
          .goodSentence {
            max-width: 100%;
            p {
              white-space:nowrap;
              // color: #ffffff;
              font-weight: 400;
              overflow:hidden;
            }
            .noplaying {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              white-space: normal;
              .local {
                display: none;
              }
            }
          }
          &:hover {
            .english {
              display: none;
            }
            .local {
              display: inline !important;
            }
          }
        }
      }
</style>
